import * as Sentry from '@sentry/react';

export const init = () => {
  if (!SENTRY_DSN || LEVEL === 'local') {
    console.log('='.repeat(40));
    console.log('Sentry not initialized');
    console.log('='.repeat(40));
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    release: TAG || 'unknown', // should be match with config
    environment: LEVEL || 'unknown',
    tunnel: '/api/internal/v1/system/sentry-frontend-logs',
    tracesSampleRate: 0,
  });
};

export const captureException = (
  error: Error,
  context?: Record<string, unknown>,
) => {
  if (!Sentry.isInitialized()) {
    console.error(error);
    return;
  }

  Sentry.captureException(error, { extra: context });
};

export const setSentryUser = (user: Sentry.User) => {
  if (!Sentry.isInitialized()) return;

  Sentry.setUser(user);
};

export const setSentryTag = (key: string, value: string) => {
  if (!Sentry.isInitialized()) return;

  Sentry.setTag(key, value);
};

export const captureLog = (
  message: string,
  context?: Record<string, unknown>,
) => {
  if (!Sentry.isInitialized()) return;

  Sentry.captureMessage(message, {
    level: 'log',
    extra: context,
  });
};
